import React from 'react';

/**
 * Engagement status badge for barbers.
 * Statuses: active | low_activity | suspended | archived
 */
const STATUS_CONFIG = {
  active: {
    label: 'Active',
    dot: '#22c55e', // green
    bg: 'rgba(34,197,94,0.12)',
    text: '#86efac',
    border: 'rgba(34,197,94,0.35)',
    hint: 'Using the app regularly',
  },
  low_activity: {
    label: 'Low Activity',
    dot: '#eab308', // yellow
    bg: 'rgba(234,179,8,0.12)',
    text: '#fde68a',
    border: 'rgba(234,179,8,0.35)',
    hint: 'No activity for 30+ days',
  },
  suspended: {
    label: 'Suspended',
    dot: '#ef4444', // red
    bg: 'rgba(239,68,68,0.12)',
    text: '#fca5a5',
    border: 'rgba(239,68,68,0.4)',
    hint: 'Hidden from bookings',
  },
  archived: {
    label: 'Archived',
    dot: '#71717a', // gray
    bg: 'rgba(113,113,122,0.18)',
    text: '#d4d4d8',
    border: 'rgba(113,113,122,0.4)',
    hint: 'No longer with Sauce Sity',
  },
};

export const EngagementStatusBadge = ({ status, size = 'sm', showHint = false, testId }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.low_activity;
  const padding = size === 'lg' ? '6px 12px' : '3px 9px';
  const fontSize = size === 'lg' ? '0.8rem' : '0.72rem';
  return (
    <span
      data-testid={testId || `engagement-badge-${status}`}
      title={cfg.hint}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding,
        fontSize,
        fontWeight: 700,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        borderRadius: 999,
        background: cfg.bg,
        color: cfg.text,
        border: `1px solid ${cfg.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: '999px',
          background: cfg.dot,
          boxShadow: `0 0 8px ${cfg.dot}`,
        }}
      />
      {cfg.label}
      {showHint && (
        <span style={{ marginLeft: 6, opacity: 0.75, textTransform: 'none', fontWeight: 500 }}>
          — {cfg.hint}
        </span>
      )}
    </span>
  );
};

export const ENGAGEMENT_STATUSES = Object.keys(STATUS_CONFIG);

export default EngagementStatusBadge;
